import React, { useState, useEffect } from 'react'
import { Table, Flex, Space, App, Form, Input, Button,Radio} from 'antd';
import Main from '../../cpn/Main'
import { useKhmdListQuery, useKhmdDelMutation } from '../../store/BnsKeJiApi'
import Copy from '../../cpn/Copy'
import ContactAdd from './ContactAdd'
import ContactEdit from './ContactEdit'
function ContactList() {
    const [form] = Form.useForm()
    const {modal,message} = App.useApp()
    const eu_id = JSON.parse(localStorage.getItem('eu_id'))
    const eu_name = JSON.parse(localStorage.getItem('eu_name'))
    const [list, setList] = useState([]);
    const [query,setQuery] = useState({
        khmd_phone:'',
        khmd_content:'',
        khmd_gzwx_id:'1',
    })
    const {data,isSuccess} = useKhmdListQuery(query,{refetchOnMountOrArgChange:1})
   
    useEffect(() => {
        if(isSuccess&&data.Status==='success'){
            const arr = data.Result.map(item => {
                const {khmd_id:key,khmd_phone,khmd_content,khmd_ctime,khmd_uname,khmd_gzwx_id,khmd_gzwx_name,khmd_gzwx_phone,khmd_gzwx_time} = item;
                return item = {key,khmd_phone,khmd_content,khmd_ctime,khmd_uname,khmd_gzwx_id,khmd_gzwx_name,khmd_gzwx_phone,khmd_gzwx_time}
            })
            arr.sort((a, b) => {
                return new Date(b.khmd_ctime) - new Date(a.khmd_ctime)
            })
            if(query.khmd_gzwx_id==='1'){
                setList(arr)
            }else if(query.khmd_gzwx_id==='2'){
                setList(arr.filter(item => item.khmd_gzwx_time))
            }else if(query.khmd_gzwx_id==='3'){
                setList(arr.filter(item => !item.khmd_gzwx_time))
            }
        }
    }, [data, isSuccess,query.khmd_gzwx_id])
    const [del] = useKhmdDelMutation()
    const columns = [
        {
            title: '手机号/微信号',
            dataIndex: 'khmd_phone',
            render: (text, record) => (
                <Space>
                    <Copy title={record.khmd_phone} />
                </Space>
            ),
        },
       
        {
            title: '备注',
            dataIndex: 'khmd_content',
        },
        {
            title: '加好友时间',
            dataIndex: 'khmd_gzwx_time',            
        },
        {
            title: '加好友微信昵称',
            dataIndex: 'khmd_gzwx_name',          
        },
        {
            title: '加好友手机号码',
            dataIndex: 'khmd_gzwx_phone',
          
        },
        {
            title: '新增时间',
            dataIndex: 'khmd_ctime',
            render: (text, record) => (
                <>{record.khmd_ctime + record.khmd_uname}</>
            ),
        },
        {
            title: '操作',
            dataIndex: 'action',
            render: (text, record) => (
                <Space>
                    <ContactEdit eu_id={eu_id} eu_name={eu_name} khmd_phone={record.khmd_phone} khmd_content={record.khmd_content} khmd_id={record.key}/>
                    <a onClick={() => {
                        modal.confirm({
                            title: '确定删除吗?',
                            content: '删除后不能恢复',
                            okText: '确认',
                            okType: 'danger',
                            cancelText: '取消',
                            onOk: () => {
                                del({khmd_id:record.key}).then((res) => {
                                    if(res.data.Status==='success'){
                                        message.success('删除成功！')
                                    }else{
                                        message.error('删除失败！'+res.data.Message)
                                    }
                                })
                            }
                        })
                    }}>
                        删除
                    </a>
                    
                </Space>
            ),  
        },
    ]   
    return (
        <Main selectedKeys={['/ContactList']}  >
            <Flex align='center' justify='space-between'>
                <Form
                    layout='inline'
                    form={form}
                    name='form_contact_list'
                    initialValues={{modifier: 'public',}}
                >
                    <Form.Item name='khmd_phone' label='手机号码/微信号'>
                        <Input onChange={(e) => {setQuery(prevState=>({...prevState,khmd_phone:e.target.value}))}} />
                    </Form.Item>
                    <Form.Item name='khmd_content' label='备注'>
                        <Input onChange={(e) => {setQuery(prevState=>({...prevState,khmd_content:e.target.value}))}} />
                    </Form.Item>
                    <Form.Item name='khmd_gzwx_id' >
                        <Radio.Group value={query.khmd_gzwx_id} onChange={(e) => {setQuery(prevState=>({...prevState,khmd_gzwx_id:e.target.value}))}}>
                            <Radio value='1'>全部</Radio>
                            <Radio value='2'>已加</Radio>
                            <Radio value='3'>未加</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item>
                        <Button 
                            onClick={() => {
                                form.resetFields();
                                setQuery(prevState=>({...prevState,khmd_phone:'',khmd_content:''}))
                            }}
                        >重置</Button>
                    </Form.Item>
                </Form>
                <ContactAdd eu_id={eu_id} eu_name={eu_name} />
            </Flex>           
            <Table 
                dataSource={list} 
                columns={columns} 
                size='small'
                pagination={{showSizeChanger:true,defaultPageSize:'50',showTotal:(total) => `共${total}条`}} 
                style={{marginTop:"10px"}}
            />
        </Main>
    )
}

export default ContactList